export default __webpack_public_path__ + "static/media/How-does-the-STA-1.a54a8cdd.jpg";